import { CommApiInstance } from "Utils/CommApiInstance";

const RcmnInfoApi = async (
) => {
    return await CommApiInstance.post(`memb/rcmn/info`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data);
}
export default RcmnInfoApi;